import { readCookie } from "./Cookies";
import GetParamURL from "./GetParamURL";
import { getItem, removeItem, setItem } from "./LocalStorage";

let key = "CustomDimension";
let objCustomDimension = {};

const get = () => {
  objCustomDimension = getItem(key);
  return objCustomDimension;
};

const clear = () => {
  objCustomDimension = {};
  removeItem(key);
};

const set = (prop, value) => {
  if (!objCustomDimension) objCustomDimension = {};
  objCustomDimension[prop] = value;
  return objCustomDimension;
};

const save = () => {
  setItem(key, objCustomDimension);
};

const exist = () => {
  return get() !== null;
};

const setSuscriptorType = (value) => {
  set("suscriptorType", value);
};

const setRegistrado = (value) => {
  set("usuarioRegistrado", value);
};

const setUserId = (value) => {
  set("userId", value);
};

// TODO ésta func habría que cambiarla pero la línea justo antes del return está mal
// Gise me indicó que lo deje así porque así anda el viejo checkout y nadie reportó problemas
// así que lo dejo así y duplico esta func en helpers bien hecha para analytics
// debería usarse la nueva func GetLastClaimedArticleFromCallback() imo, but what do i know ¯\_(ツ)_/¯
const getNotaPaywall = () => {
  const callbackUrl = GetParamURL().URLCallback;
  const notaIdKey = '-nid';
  const notaIdKeyIndex = callbackUrl.indexOf(notaIdKey);

  if (notaIdKeyIndex < 0) {
      return null;
  }

  const notaUrlIndex = callbackUrl.lastIndexOf('/') + 1;
  const notaUrl = callbackUrl.substring(notaUrlIndex, notaIdKeyIndex);
  const notaId = callbackUrl.substring(notaIdKeyIndex + notaIdKey.length);

  return {
      id: notaId,
      url: notaUrl
  };
}

const createCustomDimension = () => { // esta func arma el json que se ve en el dataLayer de Tag Maanger (Google Analytics)
  if (!exist()) {
    setRegistrado("no");
    setSuscriptorType("N/A");
    setUserId("");
    save();
  }

  const CD = get();
  const withToken = !!!readCookie("token");
  const usuarioLogeado = withToken ? "no" : "yes";
  const payUser = !readCookie("ProductoPremiumId") ? "no" : "yes";
  const userId = readCookie("usuario%5Fid");
  const clubLN = readCookie("usuarioDetalleClubNacion");
  const notasLeidas = readCookie("countNotas");

  const notaPaywall = getNotaPaywall();
  const notaPW = notaPaywall?.id;
  const urlNotaPW = notaPaywall?.url;

  if (!window.dataLayer) {
    window.dataLayer = [{}];
  }

  dataLayer[0].notasLeidas = notasLeidas ? notasLeidas : 0;
  dataLayer[0].usuarioLogeado = usuarioLogeado;
  dataLayer[0].usuarioRegistrado = CD.usuarioRegistrado;
  dataLayer[0].payUser = payUser;
  dataLayer[0].suscriptorType = CD.suscriptorType;
  dataLayer[0].userId = userId;
  dataLayer[0].credentialType = clubLN ? clubLN : "N/A";
  dataLayer[0]['nota-PW'] = notaPW ? notaPW : '';
  dataLayer[0]['url-nota-PW'] = urlNotaPW ? urlNotaPW : '';
};

export {
  setSuscriptorType,
  setRegistrado,
  setUserId,
  save,
  createCustomDimension,
};